import type { CompanionFieldMode } from "@/lib/companionFields";

export type VehicleFieldKey =
  | "license_plate"
  | "vehicle_length_m"
  | "vehicle_width_m"
  | "vehicle_height_m"
  | "vehicle_weight_kg"
  | "tent_size";

export type VehicleFieldsConfig = Record<VehicleFieldKey, CompanionFieldMode>;

export type VehicleFieldTextConfig = Partial<Record<VehicleFieldKey, string>>;

export const NUMERIC_VEHICLE_FIELD_KEYS: VehicleFieldKey[] = [
  "vehicle_length_m",
  "vehicle_width_m",
  "vehicle_height_m",
  "vehicle_weight_kg",
];

export const VEHICLE_FIELD_ROWS: { key: VehicleFieldKey; label: string }[] = [
  { key: "license_plate", label: "Kennzeichen" },
  { key: "vehicle_length_m", label: "Länge (m)" },
  { key: "vehicle_width_m", label: "Breite (m)" },
  { key: "vehicle_height_m", label: "Höhe (m)" },
  { key: "vehicle_weight_kg", label: "Gewicht (kg)" },
  { key: "tent_size", label: "Zeltgröße" },
];

export const DEFAULT_VEHICLE_FIELDS: VehicleFieldsConfig = {
  license_plate: "off",
  vehicle_length_m: "off",
  vehicle_width_m: "off",
  vehicle_height_m: "off",
  vehicle_weight_kg: "off",
  tent_size: "off",
};

export const DEFAULT_VEHICLE_FIELDS_BY_CODE: Record<string, Partial<VehicleFieldsConfig>> = {
  motorhome: {
    license_plate: "optional",
    vehicle_length_m: "required",
    vehicle_width_m: "optional",
    vehicle_height_m: "optional",
    vehicle_weight_kg: "optional",
  },
  caravan: {
    license_plate: "optional",
    vehicle_length_m: "required",
    vehicle_weight_kg: "optional",
  },
  tow_vehicle: {
    license_plate: "required",
  },
  tent: {
    tent_size: "required",
  },
};
